import { useQuery, UseQueryFunctionResult } from "@lookiero/messaging-react";
import {
  ViewIsCompleteYourLookOfferingEnabledResult,
  viewIsCompleteYourLookOfferingEnabled,
} from "../../../../projection/offering/viewIsCompleteYourLookOfferingEnabled";
import { MESSAGING_CONTEXT_ID } from "../../../delivery/baseBootstrap";

interface UseViewIsCompleteYourLookOfferingEnabledFunction {
  (): UseQueryFunctionResult<ViewIsCompleteYourLookOfferingEnabledResult>;
}

const useViewIsCompleteYourLookOfferingEnabled: UseViewIsCompleteYourLookOfferingEnabledFunction = () =>
  useQuery({
    query: viewIsCompleteYourLookOfferingEnabled(),
    contextId: MESSAGING_CONTEXT_ID,
    options: {
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
    },
  });

export { useViewIsCompleteYourLookOfferingEnabled };
